if (!window.BaseModal) {
  window.BaseModal = class BaseModal extends HTMLElement {
    constructor() {
      super()

      this.panel = this.querySelector('[data-modal-panel]')

      this.addEventListener('keyup', (event) => {
        if (event.code === 'Escape') this.close()
      })

      this.addEventListener('click', (event) => {
        if (this.panel && !this.panel.contains(event.target)) this.close()
      })
    }

    lockScroll() {
      document.documentElement.style.overflow = 'hidden'
      document.body.classList.add('overflow-hidden')
      if (window.lenis) window.lenis.stop()
    }

    unlockScroll() {
      document.documentElement.style.overflow = ''
      document.body.classList.remove('overflow-hidden')
      if (window.lenis) window.lenis.start()
    }

    onOpen() {}

    open(triggeredBy) {
      if (triggeredBy) this.activeElement = triggeredBy

      this.classList.remove('opacity-0', 'invisible', 'is-closing')
      this.classList.add('opacity-100', 'visible')

      this.onOpen()
      this.lockScroll()

      this.addEventListener(
        'transitionend',
        () => {
          const dialog = this.querySelector('[role="dialog"]')
          if (typeof trapFocus === 'function') trapFocus(this, dialog || this)
        },
        { once: true },
      )
    }

    close() {
      if (this.classList.contains('invisible') || this.classList.contains('is-closing')) return

      this.classList.remove('opacity-100', 'visible')
      this.classList.add('opacity-0', 'is-closing')

      if (typeof removeTrapFocus === 'function') removeTrapFocus(this.activeElement)
      this.unlockScroll()

      if (!this.panel) {
        this.classList.add('invisible')
        return
      }

      const finishClose = (event) => {
        if (event.target !== this.panel || event.propertyName !== 'transform') return
        this.panel.removeEventListener('transitionend', finishClose)
        this.classList.remove('is-closing')
        this.classList.add('invisible')
      }

      this.panel.addEventListener('transitionend', finishClose)
    }
  }
}
